import { Module } from 'vuex';
import { RootState } from '@/app/app.store';
import { apiHttpClient } from '../../app/app.service';

export interface TrailIndexStoreState {
  trails: string;
  loading: boolean;
  name: string;
}

export const trailIndexStoreModule: Module<TrailIndexStoreState, RootState> = {
  /**
   * 命名空间
   */
  namespaced: true,

  /**
   * 数据
   */
  state: {
    trails: '',
    loading: false,
    name: 'trailIndexStoreModule',
  } as TrailIndexStoreState,

  /**
   * 获取器
   */
  getters: {
    trails(state) {
      return state.trails;
    },

    loading(state) {
      return state.loading;
    },
  },

  /**
   * 修改器
   */
  mutations: {
    setTrails(state, data) {
      state.trails = data;
    },

    setLoading(state, data) {
      state.loading = data;
    },
  },

  /**
   * 动作
   */
  actions: {
    async getTrails({ commit, dispatch }) {
      // let getPostsQueryString = '';

      // if (Object.keys(options).length) {
      //   getPostsQueryString = await dispatch('getPostsPreProcess', options);
      // } else {
      //   getPostsQueryString = state.queryString;
      // }
      commit('setLoading', true);

      try {
        const response = await apiHttpClient.get(
          // `/nodes?page=${state.nextPage}&${getPostsQueryString}`,
          '/trails',
        );

        dispatch('getTrailsPostProcess', response);

        return response;
      } catch (error) {
        commit('setLoading', false);
        throw error.response;
      }
    },

    getTrailsPostProcess({ commit }, response) {
      commit('setTrails', response.data);
      commit('setLoading', false);
      //
      // if (state.nextPage === 1) {
      //   commit('setPosts', response.data);
      // } else {
      //   commit('setPosts', [...state.posts, ...response.data]);
      // }

      // commit('setLoading', false);

      // const total =
      //   response.headers['X-Total-Count'] || response.headers['x-total-count'];

      // const totalPages = Math.ceil(total / POSTS_PER_PAGE);

      // commit('setTotalPages', totalPages);

      // commit('setNextPage');
    },
  },

  /**
   * 模块
   */
  modules: {},
};
